import React from 'react';
import { useLang } from '../context/LanguageContext';
import './Footer.css';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="footer">
      <span className="footer__name">Veronika Levy</span>
      <span className="footer__rights">{t.footer.rights}</span>
    </footer>
  );
}
